import { formatInTimeZone } from "date-fns-tz";
import type { Locale } from "date-fns";

export const APP_TIMEZONE = "Asia/Seoul";

/**
 * Format a timestamp in a fixed timezone so SSR and client agree.
 *
 * Why: rendering `format(new Date(timestamp), pattern, { locale })` directly
 * inside JSX makes the output depend on the runtime's local timezone, which
 * differs between the server container (UTC) and the user's browser. The
 * resulting text mismatch throws React #418 and pollutes Sentry.
 */
export function formatAppDateTime(
  value: string | number | Date,
  pattern: string,
  options?: { locale?: Locale; timeZone?: string },
): string {
  return formatInTimeZone(
    new Date(value),
    options?.timeZone ?? APP_TIMEZONE,
    pattern,
    { locale: options?.locale },
  );
}
